/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode } from "react";
import containerStyle from "./containerStyle";
import { Box, SxProps, Theme } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx";

export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  showPaddingBlock?: boolean;
  variant?: "xs" | "sm" | "md" | "lg" | "xl" | "full";
  id?: string;
  sx?: SxProps<Theme>;
};

export default function Container({ sx, children, showPaddingBlock = true, variant = "md", id }: ContainerProps) {
  return (
    <Box
      id={id}
      sx={mergeSx(
        containerStyle.container,
        showPaddingBlock && containerStyle.paddingBlock,
        variant === "xs" && containerStyle.containerXs,
        variant === "sm" && containerStyle.containerSm,
        variant === "md" && containerStyle.containerMd,
        variant === "lg" && containerStyle.containerLg,
        variant === "xl" && containerStyle.containerXl,
        sx,
      )}
    >
      {children}
    </Box>
  );
}
